export const exists = (variable) => !(typeof variable === 'undefined')
